import { ReactNode } from "react";
import { Card, CardHeader } from "../sections";

export const SingleMetricCard = ({
  icon,
  title,
  description,
  metric,
  children,
}: {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  metric: ReactNode;
  children?: ReactNode;
}) => (
  <Card className="flex flex-col gap-4">
    <div className="flex gap-4">
      <div className="flex flex-1 flex-col gap-4">
        <CardHeader>
          {icon}
          {title}
        </CardHeader>
        <div className="text-base">{description}</div>
      </div>
      {metric}
    </div>
    {children}
  </Card>
);
